import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';


class BFWOfferCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {

    let offerId = this.props.offerId;
    let orgLogoUrl = this.props.orgLogoUrl;
    let title = this.props.title;
    let thumbNailCopy = this.props.thumbNailCopy;
    let organizationName = this.props.organizationName;
    let expiration = this.props.expiration;
    let never_expires = this.props.never_expires;

    if (expiration == null || never_expires) {
      expiration = '';
    } else {
      expiration = 'Expires ' + this.props.expiration;
    }
    let websiteUrl = this.props.website;


    return(
        <div className="offerCard-wrapper">
          <a target="_blank" href={websiteUrl}><div className="offerCard">

            <div className="offerCard-logoWrapper">
              <div className="offerCard-logo">
                <img className="offerCard-bannerFilter" src={orgLogoUrl} />

              </div>
              <div className="offerCard-orgName">
                {organizationName}
              </div>
            </div>

            <div className="offerCard-copyWrapper">
              <div className="offerCard-title">
                {title}
              </div>

              <div className="offerCard-thumbNailCopy">
                {thumbNailCopy}
              </div>



              <div className="offerCard-footerWrapper">

                <div className="offerCard-footerWrapperInner">
                  <div className="offerCard-footerLeft">
                    Access Offer
                  </div>

                  <div className="offerCard-footerRight">
                     {expiration}
                  </div>
                </div>

              </div>
            </div>




          </div></a>
        </div>

    )
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    Link
  }
)(BFWOfferCard);



// WEBPACK FOOTER //
// ./src/components/bfwOffers/BFWOfferCard.jsx